import { Link } from "react-router-dom";

export default function AdminSideNav(props){
    return(
        <>
          <aside className="sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 fixed-start ms-4 dark-version" id="sidenav-main">
    <div className="sidenav-header">
      <i className="fas fa-times p-3 cursor-pointer text-secondary opacity-5 position-absolute end-0 top-0 d-none d-xl-none" aria-hidden="true" id="iconSidenav"></i>
      <Link className="navbar-brand m-0" to="/home" target="_blank">
        <img src="/assets/admin/img/company-logo.gif" className="navbar-brand-img h-100" alt="main_logo"/>
        <span className="ms-1 font-weight-bold">BioUniverse Dashboard</span>
      </Link>
    </div>
    <hr className="horizontal dark mt-0"/>
    <div className="collapse navbar-collapse  w-auto " id="sidenav-collapse-main">
      <ul className="navbar-nav">
        <li className="nav-item">
          <Link className= {props.active === 'Admin' ? 'nav-link active' : 'nav-link'} to="/admin">
            <div className="icon icon-shape icon-sm border-radius-md text-center me-2 d-flex align-items-center justify-content-center">
              <i className="ni ni-tv-2 text-sm opacity-10" style={{color: 'white'}}></i>
            </div>
            <span className="nav-link-text ms-1">Home</span>
          </Link>
        </li>
        <li className="nav-item">
          <div className="nav-link" >
            <div className="icon icon-shape icon-sm border-radius-md text-center me-2 d-flex align-items-center justify-content-center">
              <i className="ni ni-calendar-grid-58 text-warning text-sm opacity-10"></i>
            </div>
            <div>
              Categories
            </div>
          </div>
        </li>
        <li className="nav-item">
          <div className={props.active === 'Amphibians' ? 'nav-link active' : 'nav-link'} >
            <Link to="/admin_table_amphibians">
              ● Amphibians
            </Link>
          </div>
        </li>

        <li className="nav-item">
          <div className={props.active === 'Birds' ? 'nav-link active' : 'nav-link'} >
          <Link to="/admin_table_birds">
          ● Birds
            </Link>
          </div>
        </li>

        <li className="nav-item">
          <div className={props.active === 'Mammals' ? 'nav-link active' : 'nav-link'} >
            <Link to="/admin_table_mammals">
            ● Mammals
            </Link>
          </div>
        </li>

        <li className="nav-item">
          <div className={props.active === 'Marines' ? 'nav-link active' : 'nav-link'} >
            <Link to="/admin_table_marines">
            ● Marines
            </Link>
          </div>
        </li>

        <li className="nav-item">
          <div className={props.active === 'Reptiles' ? 'nav-link active' : 'nav-link'} >
            <Link to="/admin_table_reptiles">
            ● Reptiles
            </Link>
          </div>
        </li>

        <li className="nav-item">
          <div className={props.active === 'Endangered' ? 'nav-link active' : 'nav-link'} >
            <Link to="/admin_table_endangered">
            ● Endangered
            </Link>
          </div>
        </li>
     
       

      <hr style={{color: 'white', border: 'solid 2px', margin: 0}}/>
        <li className="nav-item mt-3">
          <h6 className="ps-4 ms-2 text-uppercase text-xs font-weight-bolder opacity-6">Account pages</h6>
        </li>
        <li className="nav-item">
          <Link className={props.active === 'user_profile' ? 'nav-link active' : 'nav-link'} to ="/admin_user_data">
            <div className="icon icon-shape icon-sm border-radius-md text-center me-2 d-flex align-items-center justify-content-center">
              <i className="ni ni-single-copy-04 text-warning text-sm opacity-10"></i>
            </div>
            <span className="nav-link-text ms-1">User Data</span>
          </Link>
        </li>
        <li className="nav-item">
          <Link className={props.active === 'user_profile_edit' ? 'nav-link active' : 'nav-link'} to="/admin_user_edit">
            <div className="icon icon-shape icon-sm border-radius-md text-center me-2 d-flex align-items-center justify-content-center">
              <i className="ni ni-single-02 text-dark text-sm opacity-10"></i>
            </div>
            <span className="nav-link-text ms-1">Edit Profile</span>
          </Link>
        </li>
      </ul>
    </div>

  </aside>
        </>
    );
}